import generateRandomKey from "@utils/generateRandomKey"

import { Icon } from "@atoms"

import { Select } from "@molecules"

import useTable from "@organisms/Table/Table.context"

import styles from "./PopoverSortingColumns.module.scss"
import { PopoverSortingColumnsProps } from "./PopoverSortingColumns.types"

export default function PopoverSortingColumns(props: PopoverSortingColumnsProps) {
    const { isVisible } = props

    const {
        sortingEnabledColumns,
        activeSorting,
        activeSortingIcons,
        activeSortingLabels,
        setCurrentSortToAscending,
        setCurrentSortToDescending,
        onSortingItemSelection,
    } = useTable()

    return (
        <div className={styles.base}>
            <Select.Root>
                <Select.Input
                    isControlled={false}
                    placeholder="Select Column"
                    className={styles.droplist}
                    isTabbable={isVisible}
                    selectedItem={
                        activeSorting && sortingEnabledColumns
                            ? {
                                  value: activeSorting.id,
                                  label:
                                      (sortingEnabledColumns.find((c) => c.accessorKey === activeSorting.id)
                                          ?.header as string) ?? "",
                              }
                            : undefined
                    }
                    size="sm"
                />
                {sortingEnabledColumns && (
                    <Select.Viewport>
                        <Select.List title="Select column" className={styles.droplist}>
                            <Select.ListSearch />
                            <Select.ListGroup>
                                {sortingEnabledColumns.map((column) => {
                                    return (
                                        <Select.ListItem
                                            variant="default"
                                            key={generateRandomKey()}
                                            item={{
                                                value: column.accessorKey as string,
                                                label: column.header as string,
                                            }}
                                            onSelect={() => onSortingItemSelection(column)}
                                            isSelected={activeSorting?.id === column.accessorKey}
                                        />
                                    )
                                })}
                            </Select.ListGroup>
                        </Select.List>
                    </Select.Viewport>
                )}
            </Select.Root>
            <Select.Root>
                <Select.Input
                    isControlled={false}
                    placeholder="Select Sort Order"
                    className={styles.droplist}
                    isTabbable={isVisible}
                    selectedItem={
                        activeSorting
                            ? {
                                  value: activeSorting.id,
                                  label: activeSorting.desc
                                      ? (activeSortingLabels?.desc ?? "")
                                      : (activeSortingLabels?.asc ?? ""),
                                  leading: activeSorting.desc ? (
                                      activeSortingIcons?.desc ? (
                                          <Icon icon={activeSortingIcons.desc} size={14} />
                                      ) : null
                                  ) : activeSortingIcons?.asc ? (
                                      <Icon icon={activeSortingIcons.asc} size={14} />
                                  ) : null,
                              }
                            : undefined
                    }
                    size="sm"
                />
                {sortingEnabledColumns && activeSorting && (
                    <Select.Viewport>
                        <Select.List title="Select sort order" className={styles.droplist}>
                            <Select.ListGroup>
                                <Select.ListItem
                                    variant="icon"
                                    item={{
                                        leading: activeSortingIcons?.asc ? (
                                            <Icon icon={activeSortingIcons?.asc} size={14} />
                                        ) : null,
                                        value: activeSorting?.id,
                                        label: activeSortingLabels?.asc ?? "",
                                    }}
                                    onSelect={setCurrentSortToAscending}
                                    isSelected={!activeSorting?.desc}
                                />
                                <Select.ListItem
                                    variant="icon"
                                    item={{
                                        leading: activeSortingIcons?.desc ? (
                                            <Icon icon={activeSortingIcons?.desc} size={14} />
                                        ) : null,
                                        value: activeSorting?.id,
                                        label: activeSortingLabels?.desc ?? "",
                                    }}
                                    onSelect={setCurrentSortToDescending}
                                    isSelected={activeSorting?.desc}
                                />
                            </Select.ListGroup>
                        </Select.List>
                    </Select.Viewport>
                )}
            </Select.Root>
        </div>
    )
}
